import Header from './newHeader';

export default Header;
